module.exports = __webpack_public_path__ + "images/marketing/peeps/zen_newman.jpg";